import { render, staticRenderFns } from "./FixedBody.vue?vue&type=template&id=34b1d0d6&scoped=true&"
import script from "./FixedBody.vue?vue&type=script&lang=js&"
export * from "./FixedBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b1d0d6",
  null
  
)

export default component.exports